/* eslint-disable @typescript-eslint/no-unused-vars */
// utils/toastConfig.ts
import React from 'react';
import {View, Text, StyleSheet, Image} from 'react-native';
import {BaseToast, ErrorToast} from 'react-native-toast-message';
import {AppTheme} from '../../utils/theme';
import { AppIcons } from '../../assets/images';

export const toastConfig = {
  success: (props: any) => (
    <BaseToast
      {...props}
      style={[styles.toastContainer, {borderLeftColor: AppTheme.colors.linearGradient_12}]}
      contentContainerStyle={styles.contentContainer}
      text1Style={styles.text1}
      text2Style={styles.text2}
      renderLeadingIcon={() => (
        <Image source={AppIcons.Logo} style={styles.icon} />
      )}
      text2NumberOfLines={3}
    />
  ),
  error: (props: any) => (
    <ErrorToast
      {...props}
      style={[styles.toastContainer, {borderLeftColor: AppTheme.colors.linearGradient_6}]}
      contentContainerStyle={styles.contentContainer}
      text1Style={styles.text1}
      text2Style={styles.text2}
      renderLeadingIcon={() => (
        <Image source={AppIcons.Logo} style={styles.icon} />
      )}
      text2NumberOfLines={3}
    />
  ),
  info: (props: any) => (
    <BaseToast
      {...props}
      style={[
        styles.toastContainer,
        {borderLeftColor: AppTheme.colors.linearGradient_1},
      ]}
      contentContainerStyle={styles.contentContainer}
      text1Style={styles.text1}
      text2Style={styles.text2}
      renderLeadingIcon={() => (
        <Image source={AppIcons.Logo} style={styles.icon} />
      )}
      text2NumberOfLines={3}
    />
  ),
};

const styles = StyleSheet.create({
  toastContainer: {
    borderLeftWidth: 0,
    borderRadius: 10,
    backgroundColor: AppTheme.colors.white,
    paddingHorizontal: 12,
    width: '95%',
  },
  contentContainer: {
    paddingHorizontal: 15,
  },
  text1: {
    fontSize: 16,
    fontFamily: AppTheme.fonts.ALEXANDRIA_MEDIUM,
    color: AppTheme.colors.black,
  },
  text2: {
    fontSize: 14,
    fontFamily: AppTheme.fonts.ALEXANDRIA_MEDIUM,
    color: AppTheme.colors.black,
  },
  icon: {
    width: 42,
    height: 42,
    borderRadius: 10,
    alignSelf: 'center',
  },
});
